"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("line-height:", theme.lineHeight.leadingNormal, ";font-size:", theme.fontSize.base, ";overflow:hidden;margin-top:0!important;&&>*{margin-top:2px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=SubMenu.styles.js.map